import { NonFousableTooltipTarget, Tooltip, TooltipTrigger } from '@/components/react-aria/tooltip';
import { useRasContext } from '@/renderer/utils/useRasContext';
import { twMerge } from 'tailwind-merge';
import { ConnectionStatus } from './ConnectionStatus';

const TEXT = {
  [ConnectionStatus.Loading]: 'Loading...',
  [ConnectionStatus.Offline]: 'Your device appears to be offline',
  [ConnectionStatus.SlowCellular]: 'Slow connection: Real-time messaging may be affected',
  [ConnectionStatus.PollingUnstable]:
    'Severely unstable: Real-time messaging may be affected (frequent errors)',
  [ConnectionStatus.WebsocketDisconnected]: 'Real-time messaging may be delayed (polling)',
  [ConnectionStatus.WebsocketUnstable]: 'Real-time messaging may be affected (unstable)',
  [ConnectionStatus.Stable]: 'Stable connection',
};

export default function ConnectionStatusIcon() {
  const rasContext = useRasContext();
  const connectionStrength =
    rasContext.data?.connectionStatus === undefined
      ? ConnectionStatus.Stable
      : rasContext.data?.connectionStatus;

  const connectionText = TEXT[connectionStrength];

  return (
    <TooltipTrigger delay={1000}>
      <NonFousableTooltipTarget>
        <div className="relative ml-2 flex flex-row items-end space-x-0.5">
          {connectionStrength === ConnectionStatus.Offline && (
            <div className="absolute bottom-1 left-0 h-1 w-6 origin-center rotate-45 rounded-full border border-[Canvas] bg-red-500" />
          )}
          <div
            className={twMerge(
              'h-1 w-[3px] rounded-sm bg-zinc-300 dark:bg-zinc-600',
              connectionStrength > ConnectionStatus.Offline && 'bg-zinc-800 dark:bg-zinc-300',
            )}
          />
          <div
            className={twMerge(
              'h-2 w-[3px] rounded-sm bg-zinc-300 dark:bg-zinc-600',
              connectionStrength >= ConnectionStatus.WebsocketDisconnected &&
                'bg-zinc-800 dark:bg-zinc-300',
            )}
          />
          <div
            className={twMerge(
              'h-3 w-[3px] rounded-sm bg-zinc-300 dark:bg-zinc-600',
              connectionStrength >= ConnectionStatus.WebsocketUnstable &&
                'bg-zinc-800 dark:bg-zinc-300',
            )}
          />
          <div
            className={twMerge(
              'h-4 w-[3px] rounded-sm bg-zinc-300 dark:bg-zinc-600',
              connectionStrength >= ConnectionStatus.Stable && 'bg-zinc-800 dark:bg-zinc-300',
            )}
          />
        </div>
      </NonFousableTooltipTarget>
      <Tooltip>{connectionText}</Tooltip>
    </TooltipTrigger>
  );
}
